// Per-course outcomes returned by the deleteCourses mutation. Deletion is
// all-or-nothing per course, never per batch: courses carrying academic
// history come back blocked with a reason while the clean ones delete.

import type { CourseDeleteOutcome } from '@/types/composition-functions';

export type { CourseDeleteOutcome };

export type CourseDeleteSummary = {
  deletedCount: number;
  blocked: CourseDeleteOutcome[];
  deactivatableIds: string[];
};

export function summarizeDeleteOutcomes(outcomes: CourseDeleteOutcome[]): CourseDeleteSummary {
  const blocked = outcomes.filter((o) => !o.deleted);

  return {
    deletedCount: outcomes.filter((o) => o.deleted).length,
    blocked,
    // Only a real, visible course can be retired instead — a "not found"
    // outcome (course_code null) has nothing to deactivate.
    deactivatableIds: blocked.filter((o) => o.course_code !== null).map((o) => o.id),
  };
}
